import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectLocale } from "@jidlomat/terminal-core/slices/appStateSlice";
import { useCallback } from "react";

const FALLBACK_CURRENCY = "CZK";
const DEFAULT_DECIMAL_PLACES = 2;

export const usePriceFormat = () => {
	const locale = useAppSelector(selectLocale);

	const parsePrice = (price: string): number => Number.parseFloat(price);

	const formatPrice = useCallback(
		(price?: string | number | null, currency?: string | null): string => {
			if (!price) {
				return new Intl.NumberFormat(locale, {
					style: "currency",
					currency: currency ?? FALLBACK_CURRENCY,
					maximumFractionDigits: DEFAULT_DECIMAL_PLACES,
				}).format(0);
			}

			const actualPrice = typeof price === "string" ? parsePrice(price) : price;

			return new Intl.NumberFormat(locale, {
				style: "currency",
				currency: currency ?? FALLBACK_CURRENCY,
				maximumFractionDigits: DEFAULT_DECIMAL_PLACES,
			}).format(actualPrice);
		},
		// biome-ignore lint/correctness/useExhaustiveDependencies: parsePrice is intentionally in deps for memoization
		[locale, parsePrice],
	);

	return { formatPrice: formatPrice, parsePrice: parsePrice };
};
